export default () => {
    return (
        <div className="page-content">
			<div className="tab-header"></div>
			<div className="covid">
				As our patients know, we have continued to keep up to date with current NYS Health Department and CDC guidelines to provide a safe dental environment. We appreciate the overwhelming cooperation we've received from patients during this epidemic. We understand the questions that we have to ask and precautions have tested many people's patience, but they're important to follow in order to keep us all safe.
				<br/><br/>
				<div className="covid">Thanks for all your support and cooperation in helping us keep everyone safe during your visit.</div><br/><br/>
			</div>

            <div>
                Dr. Kisiel and his staff are adept at performing all standard dental procedures, including crowns, bridges, partial and full dentures, implants, 
                implant-retained crowns and dentures, root canals, extractions, tooth-colored restorations, and more. We won't try to make you pay for anything you don't 
                need, nor will we perform anything we aren't comfortable with &#8211; if we don't think we can do something we have no problems referring you to a 
                trusted nearby specialist who can.
            </div>
		</div>
    );
};